import { Schema } from 'src/utils/form';

export default Schema.object({
  tipoAcessoArea: Schema.string(),
});
